<script setup>
import { ref } from "vue";
import { Link } from "@inertiajs/vue2";
import LessonDetailContact from "./LessonDetailContact.vue";

// Props

const props = defineProps({
    user: {
        type: Object,
        required: true,
    },
    billingUser: {
        type: Object,
        default: null,
        required: false,
    },
    title: {
        type: String,
        required: true,
    },
    large: {
        type: Boolean,
        default: false,
    },
});

// Reactive State

const showContact = ref(false);
</script>

<template>
    <div class="lesson-detail-user">
        <v-list-item class="gap-4">
            <v-list-item-avatar
                class="cursor-pointer shadow-md"
                @click="showContact = true"
            >
                <v-img :src="user.profile_photo_url" />
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-subtitle>{{ title }}</v-list-item-subtitle>
                <v-list-item-title :class="{ 'soli-subtitle': large }">
                    <Link :href="`/profile/${user.id}/account`">
                        {{ user.name }}
                    </Link>
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{ user.email }}
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <LessonDetailContact
            v-if="showContact"
            :title="user.name"
            :contact="billingUser ?? user"
            @reset="showContact = false"
        />
    </div>
</template>
